import { Article } from "@/types/article";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { ArticleTableRow } from "./ArticleTableRow";

interface RegularArticlesTableProps {
  articles: Article[] | undefined;
  onDelete: (id: string, isSpecial?: boolean) => void;
  deletingId: string | null;
}

export const RegularArticlesTable = ({
  articles,
  onDelete,
  deletingId,
}: RegularArticlesTableProps) => {
  return (
    <div className="rounded-lg border bg-card">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>タイトル</TableHead>
            <TableHead>カテゴリ</TableHead>
            <TableHead>投稿日</TableHead>
            <TableHead className="text-right">操作</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {articles?.map((article) => (
            <ArticleTableRow
              key={article.id}
              id={article.id}
              title={article.title}
              category={article.category}
              createdAt={article.created_at}
              onDelete={onDelete}
              deletingId={deletingId}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
